import * as clack from '@clack/prompts'
import path from 'node:path'
import type { UpdateDepsCommandOptions } from '@cli-types/core-engine/commands.js'
import { detectPackageManager } from '@cli-utils/process.js'
import { spinner } from '@cli-utils/terminal.js'
import { resolveConfigOrExit } from '@next-adapter/config/resolve-config-or-exit.js'
import { getCliDependencySyncPlan } from '@next-adapter/init/scaffolders/dependencies/get-cli-dependency-sync-plan.js'
import { getDependencyPlan } from '@next-adapter/init/scaffolders/dependencies/get-dependency-plan.js'
import { installDependenciesAsync } from '@next-adapter/init/scaffolders/dependencies/install-dependencies-async.js'
import { getInstalledIntegrations } from '@next-adapter/integration-runtime/get-installed-integrations.js'
import { getInstalledPresets } from '@next-adapter/preset-runtime/get-installed-presets.js'

export async function runUpdateDepsCommand(options: UpdateDepsCommandOptions): Promise<void> {
  const cwd = options.cwd ? path.resolve(options.cwd) : process.cwd()

  clack.intro('BetterStart Update Dependencies')

  const pm = detectPackageManager(cwd)
  clack.log.info(`Package manager: ${pm}`)

  const config = await resolveConfigOrExit(cwd)
  const dependencyPlan = getDependencyPlan(
    getInstalledPresets(config),
    getInstalledIntegrations(config),
    false
  )
  const cliDependencyPlan = getCliDependencySyncPlan(cwd)

  const s = spinner()
  s.start('Installing dependencies...')

  const result = await installDependenciesAsync({
    cwd,
    pm,
    dependencies: Array.from(
      new Set([...dependencyPlan.dependencies, ...(cliDependencyPlan?.dependencies ?? [])])
    ),
    devDependencies: Array.from(
      new Set([...dependencyPlan.devDependencies, ...(cliDependencyPlan?.devDependencies ?? [])])
    )
  })

  if (result.success) {
    s.stop(`Installed ${result.dependencies.length} deps + ${result.devDeps.length} dev deps`)
  } else {
    s.stop('Dependency install failed')
    clack.log.error(result.error ?? 'Unknown error')
    process.exit(1)
  }

  clack.outro('Dependencies updated')
}
